export interface WorldCountriesList {
    id: string;
    geoId: string;
    name: string;
    continent: string;
}

export const worldCountriesList: WorldCountriesList[] = [
    { id: 'AF', name: 'Afghanistan', geoId: 'AFG', continent: 'Asia' },
    { id: 'AL', name: 'Albania', geoId: 'ALB', continent: 'Europe' },
    { id: 'DZ', name: 'Algeria', geoId: 'DZA', continent: 'Africa' },
    { id: 'AS', name: 'American Samoa', geoId: 'ASM', continent: 'Oceania' },
    { id: 'AD', name: 'Andorra', geoId: 'AND', continent: 'Europe' },
    { id: 'AO', name: 'Angola', geoId: 'AGO', continent: 'Africa' },
    { id: 'AI', name: 'Anguilla', geoId: 'AIA', continent: 'North America' },
    { id: 'AG', name: 'Antigua and Barbuda', geoId: 'ATG', continent: 'North America' },
    { id: 'AR', name: 'Argentina', geoId: 'ARG', continent: 'South America' },
    { id: 'AM', name: 'Armenia', geoId: 'ARM', continent: 'Asia' },
    { id: 'AW', name: 'Aruba', geoId: 'ABW', continent: 'North America' },
    { id: 'AU', name: 'Australia', geoId: 'AUS', continent: 'Australia' },
    { id: 'AT', name: 'Austria', geoId: 'AUT', continent: 'Europe' },
    { id: 'AZ', name: 'Azerbaijan', geoId: 'AZE', continent: 'Asia' },
    { id: 'BS', name: 'Bahamas (the)', geoId: 'BHS', continent: 'North America' },
    { id: 'BH', name: 'Bahrain', geoId: 'BHR', continent: 'Asia' },
    { id: 'BD', name: 'Bangladesh', geoId: 'BGD', continent: 'Asia' },
    { id: 'BB', name: 'Barbados', geoId: 'BRB', continent: 'North America' },
    { id: 'BY', name: 'Belarus', geoId: 'BLR', continent: 'Europe' },
    { id: 'BE', name: 'Belgium', geoId: 'BEL', continent: 'Europe' },
    { id: 'BZ', name: 'Belize', geoId: 'BLZ', continent: 'North America' },
    { id: 'BJ', name: 'Benin', geoId: 'BEN', continent: 'Africa' },
    { id: 'BM', name: 'Bermuda', geoId: 'BMU', continent: 'North America' },
    { id: 'BT', name: 'Bhutan', geoId: 'BTN', continent: 'Asia' },
    { id: 'BO', name: 'Bolivia (Plurinational State of)', geoId: 'BOL', continent: 'South America' },
    { id: 'BQ', name: 'Bonaire, Sint Eustatius and Saba', geoId: 'BES', continent: 'North America' },
    { id: 'BA', name: 'Bosnia and Herzegovina', geoId: 'BIH', continent: 'Europe' },
    { id: 'BW', name: 'Botswana', geoId: 'BWA', continent: 'Africa' },
    { id: 'BV', name: 'Bouvet Island', geoId: 'BVT', continent: 'Antarctica' },
    { id: 'BR', name: 'Brazil', geoId: 'BRA', continent: 'South America' },
    { id: 'IO', name: 'British Indian Ocean Territory (the)', geoId: 'IOT', continent: 'Asia' },
    { id: 'BN', name: 'Brunei Darussalam', geoId: 'BRN', continent: 'Asia' },
    { id: 'BG', name: 'Bulgaria', geoId: 'BGR', continent: 'Europe' },
    { id: 'BF', name: 'Burkina Faso', geoId: 'BFA', continent: 'Africa' },
    { id: 'BI', name: 'Burundi', geoId: 'BDI', continent: 'Africa' },
    { id: 'CV', name: 'Cabo Verde', geoId: 'CPV', continent: 'Africa' },
    { id: 'KH', name: 'Cambodia', geoId: 'KHM', continent: 'Asia' },
    { id: 'CM', name: 'Cameroon', geoId: 'CMR', continent: 'Africa' },
    { id: 'CA', name: 'Canada', geoId: 'CAN', continent: 'North America' },
    { id: 'CA-ON', name: 'Canada (Ontario)', geoId: 'CAN', continent: 'North America' },
    { id: 'KY', name: 'Cayman Islands (the)', geoId: 'CYM', continent: 'North America' },
    { id: 'CF', name: 'Central African Republic (the)', geoId: 'CAF', continent: 'Africa' },
    { id: 'TD', name: 'Chad', geoId: 'TCD', continent: 'Africa' },
    { id: 'CL', name: 'Chile', geoId: 'CHL', continent: 'South America' },
    { id: 'CN', name: 'China', geoId: 'CHN', continent: 'Asia' },
    { id: 'CX', name: 'Christmas Island', geoId: 'CXR', continent: 'Asia' },
    { id: 'CC', name: 'Cocos (Keeling) Islands (the)', geoId: 'CCK', continent: 'Asia' },
    { id: 'CO', name: 'Colombia', geoId: 'COL', continent: 'South America' },
    { id: 'KM', name: 'Comoros (the)', geoId: 'COM', continent: 'Africa' },
    { id: 'CD', name: 'Congo (the Democratic Republic of the)', geoId: 'COD', continent: 'Africa' },
    { id: 'CG', name: 'Congo (the)', geoId: 'COG', continent: 'Africa' },
    { id: 'CK', name: 'Cook Islands (the)', geoId: 'COK', continent: 'Oceania' },
    { id: 'CR', name: 'Costa Rica', geoId: 'CRI', continent: 'North America' },
    { id: 'HR', name: 'Croatia', geoId: 'HRV', continent: 'Europe' },
    { id: 'CU', name: 'Cuba', geoId: 'CUB', continent: 'North America' },
    { id: 'CW', name: 'Curaçao', geoId: 'CUW', continent: 'North America' },
    { id: 'CY', name: 'Cyprus', geoId: 'CYP', continent: 'Asia' },
    { id: 'CZ', name: 'Czechia', geoId: 'CZE', continent: 'Europe' },
    { id: 'CI', name: 'Cote d\'Ivoire', geoId: 'CIV', continent: 'Africa' },
    { id: 'DK', name: 'Denmark', geoId: 'DNK', continent: 'Europe' },
    { id: 'DJ', name: 'Djibouti', geoId: 'DJI', continent: 'Africa' },
    { id: 'DM', name: 'Dominica', geoId: 'DMA', continent: 'North America' },
    { id: 'DO', name: 'Dominican Republic (the)', geoId: 'DOM', continent: 'North America' },
    { id: 'EC', name: 'Ecuador', geoId: 'ECU', continent: 'South America' },
    { id: 'EG', name: 'Egypt', geoId: 'EGY', continent: 'Africa' },
    { id: 'SV', name: 'El Salvador', geoId: 'SLV', continent: 'North America' },
    { id: 'GQ', name: 'Equatorial Guinea', geoId: 'GNQ', continent: 'Africa' },
    { id: 'ER', name: 'Eritrea', geoId: 'ERI', continent: 'Africa' },
    { id: 'EE', name: 'Estonia', geoId: 'EST', continent: 'Europe' },
    { id: 'SZ', name: 'Eswatini', geoId: 'SWZ', continent: 'Africa' },
    { id: 'ET', name: 'Ethiopia', geoId: 'ETH', continent: 'Africa' },
    { id: 'FK', name: 'Falkland Islands (the) [Malvinas]', geoId: 'FLK', continent: 'South America' },
    { id: 'FO', name: 'Faroe Islands (the)', geoId: 'FRO', continent: 'Europe' },
    { id: 'FJ', name: 'Fiji', geoId: 'FJI', continent: 'Oceania' },
    { id: 'FI', name: 'Finland', geoId: 'FIN', continent: 'Europe' },
    { id: 'FR', name: 'France', geoId: 'FRA', continent: 'Europe' },
    { id: 'GF', name: 'French Guiana', geoId: 'GUF', continent: 'South America' },
    { id: 'PF', name: 'French Polynesia', geoId: 'PYF', continent: 'Oceania' },
    { id: 'TF', name: 'French Southern Territories (the)', geoId: 'ATF', continent: 'Antarctica' },
    { id: 'GA', name: 'Gabon', geoId: 'GAB', continent: 'Africa' },
    { id: 'GM', name: 'Gambia (the)', geoId: 'GMB', continent: 'Africa' },
    { id: 'GE', name: 'Georgia', geoId: 'GEO', continent: 'Asia' },
    { id: 'DE', name: 'Germany', geoId: 'DEU', continent: 'Europe' },
    { id: 'GH', name: 'Ghana', geoId: 'GHA', continent: 'Africa' },
    { id: 'GI', name: 'Gibraltar', geoId: 'GIB', continent: 'Europe' },
    { id: 'GR', name: 'Greece', geoId: 'GRC', continent: 'Europe' },
    { id: 'GL', name: 'Greenland', geoId: 'GRL', continent: 'North America' },
    { id: 'GD', name: 'Grenada', geoId: 'GRD', continent: 'North America' },
    { id: 'GP', name: 'Guadeloupe', geoId: 'GLP', continent: 'North America' },
    { id: 'GU', name: 'Guam', geoId: 'GUM', continent: 'Oceania' },
    { id: 'GT', name: 'Guatemala', geoId: 'GTM', continent: 'North America' },
    { id: 'GG', name: 'Guernsey', geoId: 'GGY', continent: 'Europe' },
    { id: 'GN', name: 'Guinea', geoId: 'GIN', continent: 'Africa' },
    { id: 'GW', name: 'Guinea-Bissau', geoId: 'GNB', continent: 'Africa' },
    { id: 'GY', name: 'Guyana', geoId: 'GUY', continent: 'South America' },
    { id: 'HT', name: 'Haiti', geoId: 'HTI', continent: 'North America' },
    { id: 'HM', name: 'Heard Island and McDonald Islands', geoId: 'HMD', continent: 'Antarctica' },
    { id: 'VA', name: 'Holy See (the)', geoId: 'VAT', continent: 'Europe' },
    { id: 'HN', name: 'Honduras', geoId: 'HND', continent: 'North America' },
    { id: 'HK', name: 'Hong Kong', geoId: 'HKG', continent: 'Asia' },
    { id: 'HU', name: 'Hungary', geoId: 'HUN', continent: 'Europe' },
    { id: 'IS', name: 'Iceland', geoId: 'ISL', continent: 'Europe' },
    { id: 'IN', name: 'India', geoId: 'IND', continent: 'Asia' },
    { id: 'ID', name: 'Indonesia', geoId: 'IDN', continent: 'Asia' },
    { id: 'IR', name: 'Iran (Islamic Republic of)', geoId: 'IRN', continent: 'Asia' },
    { id: 'IQ', name: 'Iraq', geoId: 'IRQ', continent: 'Asia' },
    { id: 'IE', name: 'Ireland', geoId: 'IRL', continent: 'Europe' },
    { id: 'IM', name: 'Isle of Man', geoId: 'IMN', continent: 'Europe' },
    { id: 'IL', name: 'Israel', geoId: 'ISR', continent: 'Asia' },
    { id: 'IT', name: 'Italy', geoId: 'ITA', continent: 'Europe' },
    { id: 'JM', name: 'Jamaica', geoId: 'JAM', continent: 'North America' },
    { id: 'JP', name: 'Japan', geoId: 'JPN', continent: 'Asia' },
    { id: 'JE', name: 'Jersey', geoId: 'JEY', continent: 'Europe' },
    { id: 'JO', name: 'Jordan', geoId: 'JOR', continent: 'Asia' },
    { id: 'KZ', name: 'Kazakhstan', geoId: 'KAZ', continent: 'Asia' },
    { id: 'KE', name: 'Kenya', geoId: 'KEN', continent: 'Africa' },
    { id: 'KI', name: 'Kiribati', geoId: 'KIR', continent: 'Oceania' },
    { id: 'KP', name: 'Korea (the Democratic People\'s Republic of)', geoId: 'PRK', continent: 'Asia' },
    { id: 'KR', name: 'Korea (the Republic of)', geoId: 'KOR', continent: 'Asia' },
    { id: 'XK', name: 'Kosovo', geoId: 'XKK', continent: 'Europe' },
    { id: 'KW', name: 'Kuwait', geoId: 'KWT', continent: 'Asia' },
    { id: 'KG', name: 'Kyrgyzstan', geoId: 'KGZ', continent: 'Asia' },
    { id: 'LA', name: 'Lao People\'s Democratic Republic (the)', geoId: 'LAO', continent: 'Asia' },
    { id: 'LV', name: 'Latvia', geoId: 'LVA', continent: 'Europe' },
    { id: 'LB', name: 'Lebanon', geoId: 'LBN', continent: 'Asia' },
    { id: 'LS', name: 'Lesotho', geoId: 'LSO', continent: 'Africa' },
    { id: 'LR', name: 'Liberia', geoId: 'LBR', continent: 'Africa' },
    { id: 'LY', name: 'Libya', geoId: 'LBY', continent: 'Africa' },
    { id: 'LI', name: 'Liechtenstein', geoId: 'LIE', continent: 'Europe' },
    { id: 'LT', name: 'Lithuania', geoId: 'LTU', continent: 'Europe' },
    { id: 'LU', name: 'Luxembourg', geoId: 'LUX', continent: 'Europe' },
    { id: 'MO', name: 'Macao', geoId: 'MAC', continent: 'Asia' },
    { id: 'MG', name: 'Madagascar', geoId: 'MDG', continent: 'Africa' },
    { id: 'MW', name: 'Malawi', geoId: 'MWI', continent: 'Africa' },
    { id: 'MY', name: 'Malaysia', geoId: 'MYS', continent: 'Asia' },
    { id: 'MV', name: 'Maldives', geoId: 'MDV', continent: 'Asia' },
    { id: 'ML', name: 'Mali', geoId: 'MLI', continent: 'Africa' },
    { id: 'MT', name: 'Malta', geoId: 'MLT', continent: 'Europe' },
    { id: 'MH', name: 'Marshall Islands (the)', geoId: 'MHL', continent: 'Oceania' },
    { id: 'MQ', name: 'Martinique', geoId: 'MTQ', continent: 'North America' },
    { id: 'MR', name: 'Mauritania', geoId: 'MRT', continent: 'Africa' },
    { id: 'MU', name: 'Mauritius', geoId: 'MUS', continent: 'Africa' },
    { id: 'YT', name: 'Mayotte', geoId: 'MYT', continent: 'Africa' },
    { id: 'MX', name: 'Mexico', geoId: 'MEX', continent: 'North America' },
    { id: 'FM', name: 'Micronesia (Federated States of)', geoId: 'FSM', continent: 'Oceania' },
    { id: 'MD', name: 'Moldova (the Republic of)', geoId: 'MDA', continent: 'Europe' },
    { id: 'MC', name: 'Monaco', geoId: 'MCO', continent: 'Europe' },
    { id: 'MN', name: 'Mongolia', geoId: 'MNG', continent: 'Asia' },
    { id: 'ME', name: 'Montenegro', geoId: 'MNE', continent: 'Europe' },
    { id: 'MS', name: 'Montserrat', geoId: 'MSR', continent: 'North America' },
    { id: 'MA', name: 'Morocco', geoId: 'MAR', continent: 'Africa' },
    { id: 'MZ', name: 'Mozambique', geoId: 'MOZ', continent: 'Africa' },
    { id: 'MM', name: 'Myanmar', geoId: 'MMR', continent: 'Asia' },
    { id: 'NA', name: 'Namibia', geoId: 'NAM', continent: 'Africa' },
    { id: 'NR', name: 'Nauru', geoId: 'NRU', continent: 'Oceania' },
    { id: 'NP', name: 'Nepal', geoId: 'NPL', continent: 'Asia' },
    { id: 'NL', name: 'Netherlands (the)', geoId: 'NLD', continent: 'Europe' },
    { id: 'NC', name: 'New Caledonia', geoId: 'NCL', continent: 'Oceania' },
    { id: 'NZ', name: 'New Zealand', geoId: 'NZL', continent: 'Oceania' },
    { id: 'NI', name: 'Nicaragua', geoId: 'NIC', continent: 'North America' },
    { id: 'NE', name: 'Niger (the)', geoId: 'NER', continent: 'Africa' },
    { id: 'NG', name: 'Nigeria', geoId: 'NGA', continent: 'Africa' },
    { id: 'NU', name: 'Niue', geoId: 'NIU', continent: 'Oceania' },
    { id: 'NF', name: 'Norfolk Island', geoId: 'NFK', continent: 'Oceania' },
    { id: 'MP', name: 'Northern Mariana Islands (the)', geoId: 'MNP', continent: 'Oceania' },
    { id: 'NO', name: 'Norway', geoId: 'NOR', continent: 'Europe' },
    { id: 'OM', name: 'Oman', geoId: 'OMN', continent: 'Asia' },
    { id: 'PK', name: 'Pakistan', geoId: 'PAK', continent: 'Asia' },
    { id: 'PW', name: 'Palau', geoId: 'PLW', continent: 'Oceania' },
    { id: 'PS', name: 'Palestine, State of', geoId: 'PSE', continent: 'Asia' },
    { id: 'PA', name: 'Panama', geoId: 'PAN', continent: 'North America' },
    { id: 'PG', name: 'Papua New Guinea', geoId: 'PNG', continent: 'Oceania' },
    { id: 'PY', name: 'Paraguay', geoId: 'PRY', continent: 'South America' },
    { id: 'PE', name: 'Peru', geoId: 'PER', continent: 'South America' },
    { id: 'PH', name: 'Philippines (the)', geoId: 'PHL', continent: 'Asia' },
    { id: 'PN', name: 'Pitcairn', geoId: 'PCN', continent: 'Oceania' },
    { id: 'PL', name: 'Poland', geoId: 'POL', continent: 'Europe' },
    { id: 'PT', name: 'Portugal', geoId: 'PRT', continent: 'Europe' },
    { id: 'PR', name: 'Puerto Rico', geoId: 'PRI', continent: 'North America' },
    { id: 'QA', name: 'Qatar', geoId: 'QAT', continent: 'Asia' },
    { id: 'MK', name: 'Republic of North Macedonia', geoId: 'MKD', continent: 'Europe' },
    { id: 'RO', name: 'Romania', geoId: 'ROU', continent: 'Europe' },
    { id: 'RU', name: 'Russian Federation (the)', geoId: 'RUS', continent: 'Europe' },
    { id: 'RW', name: 'Rwanda', geoId: 'RWA', continent: 'Africa' },
    { id: 'RE', name: 'Réunion', geoId: 'REU', continent: 'Africa' },
    { id: 'BL', name: 'Saint Barthélemy', geoId: 'BLM', continent: 'North America' },
    { id: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha', geoId: 'SHN', continent: 'Africa' },
    { id: 'KN', name: 'Saint Kitts and Nevis', geoId: 'KNA', continent: 'North America' },
    { id: 'LC', name: 'Saint Lucia', geoId: 'LCA', continent: 'North America' },
    { id: 'MF', name: 'Saint Martin (French part)', geoId: 'MAF', continent: 'North America' },
    { id: 'PM', name: 'Saint Pierre and Miquelon', geoId: 'SPM', continent: 'North America' },
    { id: 'VC', name: 'Saint Vincent and the Grenadines', geoId: 'VCT', continent: 'North America' },
    { id: 'WS', name: 'Samoa', geoId: 'WSM', continent: 'Oceania' },
    { id: 'SM', name: 'San Marino', geoId: 'SMR', continent: 'Europe' },
    { id: 'ST', name: 'Sao Tome and Principe', geoId: 'STP', continent: 'Africa' },
    { id: 'SA', name: 'Saudi Arabia', geoId: 'SAU', continent: 'Asia' },
    { id: 'SN', name: 'Senegal', geoId: 'SEN', continent: 'Africa' },
    { id: 'RS', name: 'Serbia', geoId: 'SRB', continent: 'Europe' },
    { id: 'SC', name: 'Seychelles', geoId: 'SYC', continent: 'Africa' },
    { id: 'SL', name: 'Sierra Leone', geoId: 'SLE', continent: 'Africa' },
    { id: 'SG', name: 'Singapore', geoId: 'SGP', continent: 'Asia' },
    { id: 'SX', name: 'Sint Maarten (Dutch part)', geoId: 'SXM', continent: 'North America' },
    { id: 'SK', name: 'Slovakia', geoId: 'SVK', continent: 'Europe' },
    { id: 'SI', name: 'Slovenia', geoId: 'SVN', continent: 'Europe' },
    { id: 'SB', name: 'Solomon Islands', geoId: 'SLB', continent: 'Oceania' },
    { id: 'SO', name: 'Somalia', geoId: 'SOM', continent: 'Africa' },
    { id: 'ZA', name: 'South Africa', geoId: 'ZAF', continent: 'Africa' },
    { id: 'GS', name: 'South Georgia and the South Sandwich Islands', geoId: 'SGS', continent: 'Antarctica' },
    { id: 'SS', name: 'South Sudan', geoId: 'SSD', continent: 'Africa' },
    { id: 'ES', name: 'Spain', geoId: 'ESP', continent: 'Europe' },
    { id: 'LK', name: 'Sri Lanka', geoId: 'LKA', continent: 'Asia' },
    { id: 'SD', name: 'Sudan (the)', geoId: 'SDN', continent: 'Africa' },
    { id: 'SR', name: 'Suriname', geoId: 'SUR', continent: 'South America' },
    { id: 'SJ', name: 'Svalbard and Jan Mayen', geoId: 'SJM', continent: 'Europe' },
    { id: 'SE', name: 'Sweden', geoId: 'SWE', continent: 'Europe' },
    { id: 'CH', name: 'Switzerland', geoId: 'CHE', continent: 'Europe' },
    { id: 'SY', name: 'Syrian Arab Republic', geoId: 'SYR', continent: 'Asia' },
    { id: 'TW', name: 'Taiwan', geoId: 'TWN', continent: 'Asia' },
    { id: 'TJ', name: 'Tajikistan', geoId: 'TJK', continent: 'Asia' },
    { id: 'TZ', name: 'Tanzania, United Republic of', geoId: 'TZA', continent: 'Africa' },
    { id: 'TH', name: 'Thailand', geoId: 'THA', continent: 'Asia' },
    { id: 'TL', name: 'Timor-Leste', geoId: 'TLS', continent: 'Asia' },
    { id: 'TG', name: 'Togo', geoId: 'TGO', continent: 'Africa' },
    { id: 'TK', name: 'Tokelau', geoId: 'TKL', continent: 'Oceania' },
    { id: 'TO', name: 'Tonga', geoId: 'TON', continent: 'Oceania' },
    { id: 'TT', name: 'Trinidad and Tobago', geoId: 'TTO', continent: 'North America' },
    { id: 'TN', name: 'Tunisia', geoId: 'TUN', continent: 'Africa' },
    { id: 'TR', name: 'Turkey', geoId: 'TUR', continent: 'Asia' },
    { id: 'TM', name: 'Turkmenistan', geoId: 'TKM', continent: 'Asia' },
    { id: 'TC', name: 'Turks and Caicos Islands (the)', geoId: 'TCA', continent: 'North America' },
    { id: 'TV', name: 'Tuvalu', geoId: 'TUV', continent: 'Oceania' },
    { id: 'UG', name: 'Uganda', geoId: 'UGA', continent: 'Africa' },
    { id: 'UA', name: 'Ukraine', geoId: 'UKR', continent: 'Europe' },
    { id: 'AE', name: 'United Arab Emirates (the)', geoId: 'ARE', continent: 'Asia' },
    { id: 'GB', name: 'United Kingdom of Great Britain and Northern Ireland (the)', geoId: 'GBR', continent: 'Europe' },
    { id: 'UM', name: 'United States Minor Outlying Islands (the)', geoId: 'UMI', continent: 'Oceania' },
    { id: 'US', name: 'United States of America (the)', geoId: 'USA', continent: 'North America' },
    { id: 'UY', name: 'Uruguay', geoId: 'URY', continent: 'South America' },
    { id: 'UZ', name: 'Uzbekistan', geoId: 'UZB', continent: 'Asia' },
    { id: 'VU', name: 'Vanuatu', geoId: 'VUT', continent: 'Oceania' },
    { id: 'VE', name: 'Venezuela (Bolivarian Republic of)', geoId: 'VEN', continent: 'South America' },
    { id: 'VN', name: 'Viet Nam', geoId: 'VNM', continent: 'Asia' },
    { id: 'VG', name: 'Virgin Islands (British)', geoId: 'VGB', continent: 'North America' },
    { id: 'VI', name: 'Virgin Islands (U.S.)', geoId: 'VIR', continent: 'North America' },
    { id: 'WF', name: 'Wallis and Futuna', geoId: 'WLF', continent: 'Oceania' },
    { id: 'EH', name: 'Western Sahara', geoId: 'ESH', continent: 'Africa' },
    { id: 'YE', name: 'Yemen', geoId: 'YEM', continent: 'Asia' },
    { id: 'ZM', name: 'Zambia', geoId: 'ZMB', continent: 'Africa' },
    { id: 'ZW', name: 'Zimbabwe', geoId: 'ZWE', continent: 'Africa' },
    { id: 'AX', name: 'Åland Islands', geoId: 'ALA', continent: 'Europe' }
];
